module.exports = "/_next/static/images/d81211dc572868c17c6455d46cdfaf00-people-smile-at-home-lg@1x.jpg.webp";